import React from "react";
import { SxStyleProp } from "theme-ui";
import { Box } from "../Box";
import { Label } from "../Label";
import { SVG } from "../icons";

const RadioChecked: React.FunctionComponent = props => (
  <SVG {...props}>
    <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </SVG>
);

const RadioUnchecked: React.FunctionComponent = props => (
  <SVG {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </SVG>
);

const RadioIcon: React.FunctionComponent = props => (
  <React.Fragment>
    <RadioChecked
      {...props}
      sx={{
        display: "none",
        "input:checked ~ &": {
          display: "block",
        },
      }}
    />
    <RadioUnchecked
      {...props}
      sx={{
        display: "block",
        "input:checked ~ &": {
          display: "none",
        },
      }}
    />
  </React.Fragment>
);

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  sx?: SxStyleProp;
  sxWrapper?: SxStyleProp;
  name: string;
  value: string;
  label?: string | React.ReactNode;
}

const Radio: React.FunctionComponent<Props> = React.forwardRef(
  ({ sxWrapper, sx, label, ...restProps }, ref) => (
    <Label align="center" sx={{ ...sxWrapper }}>
      <Box>
        <Box
          ref={ref}
          as="input"
          type="radio"
          {...restProps}
          sx={{
            position: "absolute",
            opacity: 0,
            zIndex: -1,
            width: 1,
            height: 1,
            overflow: "hidden",
          }}
        />
        <Box
          as={RadioIcon}
          aria-hidden="true"
          sx={{
            mr: 2,
            borderRadius: "full",
            color: "gray",
            "input:checked ~ &": {
              color: "primary",
            },
            "input:focus ~ &": {
              bg: "highlight",
            },

            ...(sx as any),
          }}
        />
      </Box>
      {label}
    </Label>
  ),
);

Radio.displayName = "Radio";

export default Radio;
